import React from "react"
import { Flex, Box } from "rebass/styled-components"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

const Heading = styled.p`
  color: white;
  width: 100%;
  text-decoration: none;
  text-align: center;
  position: absolute;
  margin: 0;
  bottom: 0;
  left: 0;
  background: rgba(211, 173, 104, 0.7);
  padding: 5px 2px;
  min-height: 40px;

  &:hover {
    text-decoration: underline;
  }
`

const StyledImg = styled(GatsbyImage)`
  transition: transform 0.3s ease-in;

  &:hover {
    transform: scale(1.05);
  }
`
const PortfolioBlock = () => {
  const data = useStaticQuery(graphql`
    {
      allNodeGallery(
        filter: {
          relationships: { field_portfolio_image: { id: { ne: null } } }
        }
      ) {
        edges {
          node {
            id
            field_slider_title
            relationships {
              field_portfolio_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 300
                      height: 500
                      layout: CONSTRAINED
                    )
                  }
                }
              }
            }
            path {
              alias
            }
          }
        }
      }
    }
  `)
  return (
    <Flex width={1} mx={-1} flexWrap="wrap">
      {data.allNodeGallery.edges.map(({ node }) => (
        <Box key={node.id} width={[1, 1 / 3, 1 / 6]} px={1}>
          <Link to={node?.path?.alias}>
            <Box sx={{ overflow: "hidden", position: "relative" }}>
              {node?.relationships?.field_portfolio_image && (
                <StyledImg
                  image={
                    node?.relationships?.field_portfolio_image?.localFile
                      ?.childImageSharp?.gatsbyImageData
                  }
                />
              )}
              <Heading>{node?.field_slider_title}</Heading>
            </Box>
          </Link>
        </Box>
      ))}
    </Flex>
  )
}

export default PortfolioBlock
